import GraphqlBuilder from 'utils/request/graphql/builder'
import _ from 'lodash'
import HelperString from 'utils/helper-string'
import HelperCollection from 'utils/helper-collection'

const BATCH_WINDOW_MS = 16;

const GraphqlGroupedBuilder = {
	batches: {},
	timeoutSet: false,
	batchKey: null,
	
	forceNewBatch: () => {
		GraphqlGroupedBuilder.batchKey = null;
	},
	
	addQuery: (name, query, { variables = {}, resultPath = [], callbackSuccess = null, callbackError = null, callbackStart = null, instant = false, filterResultWithoutGuid = false} = {} ) => {
		// Check if the batch exists
		if( GraphqlGroupedBuilder.batchKey === null || !_.has( GraphqlGroupedBuilder.batches, GraphqlGroupedBuilder.batchKey ) || GraphqlGroupedBuilder.batches[ GraphqlGroupedBuilder.batchKey ].executing === true ) {
			GraphqlGroupedBuilder.batchKey = HelperString.random();
			
			GraphqlGroupedBuilder.batches[ GraphqlGroupedBuilder.batchKey ] = {
				executing: false,
				timeout: setTimeout( GraphqlGroupedBuilder.execute.bind( this, GraphqlGroupedBuilder.batchKey ), instant ? 0 : BATCH_WINDOW_MS ),
				//timeout: null,
				queries: []
			};
		}
		
		// Check if already exists?
		GraphqlGroupedBuilder.batches[ GraphqlGroupedBuilder.batchKey ].queries.push({
			name: name +'-'+ HelperString.random(),
			query,
			variables,
			filterResultWithoutGuid,
			resultPath,
			callbackStart,
			callbackSuccess,
			callbackError
		});
	},
	
	execute: ( batchKey ) => {
		const batch = GraphqlGroupedBuilder.batches[ batchKey ];
		if( !batch || batch.executing ) return;
		batch.executing = true;
		clearTimeout( batch.timeout );
		const currentQueries = batch.queries;
		let settled = false;
		const finish = ( result, error = null ) => {
			if( settled ) return;
			settled = true;
			delete GraphqlGroupedBuilder.batches[ batchKey ];
			if( GraphqlGroupedBuilder.batchKey === batchKey ) GraphqlGroupedBuilder.batchKey = null;
			const partial = error?.queryResults;
			const raw = _.get( error, [ 'response', 'data', 'data' ], {} );
			currentQueries.forEach( query => {
				try {
					if( !error ) {
						GraphqlGroupedBuilder.parseResultSuccess( query, _.get( result, query.name ) );
					} else if( partial && _.has( partial, query.name ) && !_.has( error.queryErrors, query.name ) ) {
						GraphqlGroupedBuilder.parseResultSuccess( query, partial[ query.name ] );
					} else if( !partial && _.has( raw, query.name ) && !_.has( raw[ query.name ], 'errors' ) ) {
						GraphqlGroupedBuilder.parseResultSuccess( query, raw[ query.name ]?.data ?? raw[ query.name ] );
					} else {
						query.callbackError?.( error );
					}
				} catch( callbackError ) {
					// One consumer must not prevent the other batch consumers from settling.
					console.error( 'GraphQL batch callback failed', callbackError );
				}
			});
		};
		try {
			const graphqlBuilder = new GraphqlBuilder();
			currentQueries.forEach( query => {
				return graphqlBuilder.addQuery(query.name, query.query, query.variables);
			} );
			graphqlBuilder.setOnStart( () => {
				return currentQueries.forEach(query => {
					return query.callbackStart?.();
				});
			} );
			graphqlBuilder.setOnError( error => {
				return finish(null, error);
			} );
			graphqlBuilder.setOnSuccess( result => {
				return finish(result);
			} );
			graphqlBuilder.setOnFinally( () => {
				if( !settled ) finish( null, { error: 'request_cancelled' } );
			});
			const pending = graphqlBuilder.execute();
			pending?.catch?.( error => {
				return finish(null, error);
			} );
		} catch( error ) {
			finish( null, error );
		}
	},

	parseResultSuccess: ( query, result ) => {
		if( query.callbackSuccess !== null && _.isFunction( query.callbackSuccess ) ) {
			// Find the result :)
			let queryResult = result;
			if( query.resultPath !== null ) {
				queryResult = _.get( queryResult, query.resultPath, [] );
			}
			
			// Filter when required
			if( query.filterResultWithoutGuid ) {
				queryResult = HelperCollection.filterWithoutGuid( queryResult );
			}
			
			query.callbackSuccess( queryResult );
		}
	}
}

export default GraphqlGroupedBuilder
